"use client";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import Link from "next/link";

import CompanyLogo from "./company-logo";
import { useJob } from "../_context/JobContext";

import { truncateString } from "@lib/helpers";
import { DESCRIPTION_LIMIT } from "@lib/constants";

const Company = () => {
  const { job } = useJob();

  const intl = useIntl();
  const translation: any = intl.messages["job-details"];
  const commonTranslation: any = intl.messages.common;

  const description = useMemo(
    () =>
      job?.employer?.employer_profile?.description?.replace(
        /<\/?[^>]+(>|$)/g,
        ""
      ) || "",
    [job?.employer?.employer_profile?.description]
  );
  return (
    <div className="border rounded-lg p-6">
      <div className="mb-3 flex flex-row sm:flex-col items-center sm:text-center gap-3">
        <CompanyLogo employer={job?.employer || null} />
        <div className="">
          {!job?.employer?.hideName && (
            <h3 className="font-semibold text-lg text-neutral-900">
              {job?.employer?.employer_profile?.companyName}
            </h3>
          )}
          <p className="text-neutral-700 text-sm">
            {job?.employer?.employer_profile?.customIndustry}
          </p>
        </div>
      </div>

      <p className="text-neutral-700 text-sm sm:text-[15px] mb-3">
        {truncateString(description, DESCRIPTION_LIMIT)}
        {description.length > DESCRIPTION_LIMIT ? (
          <Link
            href={`/companies/${job?.employer?.employer_profile?.slug}`}
            className="text-secondary whitespace-nowrap"
          >
            {" "}
            {commonTranslation["read-more"]}
          </Link>
        ) : null}
      </p>

      <div className="grid grid-cols-2 divide-x py-1.5 border rounded-lg text-center text-xs sm:text-sm text-neutral-700">
        <Link
          href={`/companies/${job?.employer?.employer_profile?.slug}`}
          className="py-2 hover:opacity-70 transition"
        >
          {translation?.["company-profile"]}
        </Link>
        <Link
          href={`/companies/${job?.employer?.employer_profile?.slug}#company-jobs-listing`}
          className="py-2 hover:opacity-70 transition"
        >
          {translation?.["company-jobs"]}
        </Link>
      </div>
    </div>
  );
};

export default Company;
